import React from "react";
import { ListView } from "../../ListView";
import { getValue } from "../../../utils/object.utils";
import { StudentInfoItem } from "./StudentInfoItem";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedStudentForResult,
  updatePageNo,
} from "../../../Redux/Slices/studentResuilt.slice";
import { RootState } from "../../../Redux/store";

export const StudentResultInfo = () => {
  const dispatch = useDispatch();

  const { selectedStudent, paginatedStudentList } = useSelector(
    (state: RootState) => ({
      selectedStudent: state.studentResult.selectedStudentForResult,
      pageNo: state.studentResult.pageNo,
      paginatedStudentList: state.studentResult.paginatedStudentResultList,
    })
  );

  const studentList = getValue(paginatedStudentList, "result", []);
  const totalPage = getValue(paginatedStudentList, "lastPage", 0);

  const data = studentList.map((student: any) => {
    const isSelected =
      getValue(selectedStudent, "student_id") ===
      getValue(student, "student_id");

    return {
      child: <StudentInfoItem studentData={student} />,
      isSelected,
      onListSelected: () => {
        dispatch(setSelectedStudentForResult(student));
      },
    };
  });

  return (
    <ListView
      childrens={data}
      pagination={{
        totalPage,
        onPageChange: (pageNo) => {
          dispatch(updatePageNo(pageNo));
        },
      }}
      listStyle={{
        paddingRight: "0px",
      }}
    />
  );
};
